// src/internal/string.ts
function uppercaseFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
function kebabToCamelCase(string) {
  return string.replace(/-./g, (x) => x[1].toUpperCase());
}

export {
  uppercaseFirstLetter,
  kebabToCamelCase
};
